import { defaultAttachmentTypeLabelMap } from "@inrev/common";
import { FormSection } from "@portal/components/form";
import { FormComment } from "@portal/components/form/fields/FormComment";
import { FileUpload } from "@portal/components/ui/Upload";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { type FieldValues, type Path, useController, useFormContext } from "react-hook-form";

type AdditionalInfoStepProps<T extends FieldValues> = {
	commentPath: Path<T>;
	attachmentsPath: Path<T>;
};

export const AdditionalInfoStep = <T extends FieldValues>({
	commentPath,
	attachmentsPath,
}: AdditionalInfoStepProps<T>) => {
	const { control } = useFormContext<T>();
	const { field: attachmentsField } = useController({ name: attachmentsPath, control });
	const isAdmin = useAuthenticatedUser()?.user.type === "admin";

	return (
		<div className="flex flex-col pt-[18px] pb-[125px] min-h-fit space-y-[40px]">
			<FormSection header="Submission Narrative">
				<FormComment name={commentPath} control={control} contentClassName="min-h-[200px]" />
			</FormSection>
			<FormSection topPadding header="Attachments" subHeader="Upload any additional documents">
				<FileUpload
					value={attachmentsField.value}
					onChange={attachmentsField.onChange}
					onBlur={attachmentsField.onBlur}
					allowedTypesAndLabels={defaultAttachmentTypeLabelMap}
					enableTypeSelection={isAdmin}
					allowDelete
					analyticsContext="submission-upload"
					trackingPrefix="submission-additional-info-upload"
				/>
			</FormSection>
		</div>
	);
};
